import MainLayout from '@/components/MainLayout';
import ChatProfessionalLauncher from '@/components/chat/ChatProfessionalLauncher';

type DashboardLayoutProps = {
	children: React.ReactNode;
};

/**
 * DashboardLayout component - Layout for authenticated dashboard pages
 * Uses MainLayout with default dashboard settings
 */
function DashboardLayout({ children }: DashboardLayoutProps) {
	return (
		<MainLayout
			navbar={true}
			toolbar={true}
			footer={false}
			leftSidePanel={false}
			rightSidePanel={false}
		>
			{children}
			<ChatProfessionalLauncher />
		</MainLayout>
	);
}

export default DashboardLayout;
